import { render, staticRenderFns } from "./ListTableBlank.vue?vue&type=template&id=386f5dde&scoped=true&"
import script from "./ListTableBlank.vue?vue&type=script&lang=js&"
export * from "./ListTableBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f5dde",
  null
  
)

export default component.exports